<template>
    <div class="md-cta broker-two-column-template8" :style="{ backgroundColor: bgColor }">
        <module-box
            :fullColumn="fullColumn"
            :btmSpacing="btmSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="mg-sub-title" v-if="subTitle" v-html="subTitle"></div>
            <div
                ref="content"
                class="content-box"
                :class="{
                    'mg-container': !fullColumn,
                    'mobile-no-margin': mobileNoMargin
                }"
                :style="{ minHeight: minHeight }"
            >
                <div class="left-content">
                    <site-img
                        class="left-img"
                        :src="col1PictureSrc"
                    />
                    <div class="text-box">
                        <div
                            v-if="col1Title"
                            class="title"
                            v-html="col1Title"
                        ></div>
                        <div
                            v-if="col1SubTitle"
                            class="desc"
                            v-html="col1SubTitle"
                        ></div>
                    </div>
                    <banner-button
                        :buttons="col1Buttons"
                        @callback="showRegisterPop"
                        :showArrow="showArrow"
                        :showText="false"
                        arrowIcon="icon-arrow_06"
                    />
                </div>
                <div class="right-content">
                    <site-img
                        class="right-img"
                        :src="col2PictureSrc"
                    />
                    <div class="text-box">
                        <div
                            v-if="col2Title"
                            class="title"
                            v-html="col2Title"
                        ></div>
                        <div
                            v-if="col2SubTitle"
                            class="desc"
                            v-html="col2SubTitle"
                        ></div>
                    </div>
                    <banner-button
                        :buttons="col2Buttons"
                        @callback="showRegisterPop"
                        :showArrow="showArrow"
                        :showText="false"
                        arrowIcon="icon-arrow_06"
                    />
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../broker-two-column';
export default {
    name: 'MdCtaBrokerTwoColumnTemplate8',
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta.broker-two-column-template8 {
    background: #212530;
    padding: 0 50px 50px 50px;
    .mg-title {
        width: 100%;
        color: #fff;
        font-family: var(--mg-title-font);
        font-size: 24px;
        font-weight: 700;
        line-height: 24px;
        padding-bottom: 15px;
    }
    .mg-sub-title {
        color: #fff;
        font-family: var(--font-normal);
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 0;
        margin-bottom: 30px;
        h1,h2,h3,h4,h5,h6{
            margin: 0;
        }
    }
    .content-box {
        min-height: 485px;
        display: flex;
        align-items: center;
        padding: 0;
        position: relative;
        justify-content: space-between;
    }
    .left-content,
    .right-content {
        flex: 1;
        height: 100%;
        border-radius: 20px;
        position: relative;
        display: flex;
        &.left-content {
            margin-right: 30px;
        }
    }
    .left-img,
    .right-img {
        width: 100%;
        height: 485px;
        object-fit: cover;
        border-radius: 20px;
    }

    .text-box {
        display: flex;
        width: 100%;
        height: 100%;
        padding: 0 87px;
        box-sizing: border-box;
        border-radius: 20px;
        text-align: center;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;

        .title {
            @include webkitBox(3);
            color: #fff;
            text-shadow: 0px 4px 0px rgba(0, 0, 0, 0.25);
            font-family: var(--font-normal);
            font-style: normal;
            font-weight: 400;
            font-size: 40px;
            line-height: 60px;
            margin-bottom: 30px;
            p{
               font-size: 40px; 
               color: #fff;
               text-shadow: 0px 4px 0px rgba(0, 0, 0, 0.25);
            }
        }
        .desc {
            @include webkitBox(10);
            color: #fff;
            text-shadow: 0px 2px 0px rgba(0, 0, 0, 0.25);
            font-family: var(--font-normal);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            text-align: left;
            display: none;
        }
        .title,
        .desc {
            p {
                line-height: inherit;
                overflow: hidden;
            }
        }
    }
    .banner-button {
        display: none;
        position: absolute;
        right: 30px;
        bottom: 30px;
        z-index: 10;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #fff;
        justify-content: center;
        align-items: center;
        .btn-item {
            display: block;
            width: 100%;
            height: 100%;
            min-width: 60px;
            border-radius: 50%;
            background-color: #fff;
            color: #000;
            font-size: 24px;
            margin: 0;
            padding: 0;
            border: none;
            line-height: 60px;
            text-align: center;
            .button-text {
                display: none;
            }
            i {
                transform: rotate(45deg);
                font-size: 24px;
            }
        }
    }
    .left-content:hover,
    .right-content:hover {
        .banner-button {
            display: flex;
            .btn-item {
                margin: 0;
            }
        }
        .desc{
            display: block;
        }
    }
    @include media-800 {
        padding: 0 15px 25px 15px;
        .mg-title {
            font-size: 16px;
            line-height: 18px;
            padding-bottom: 10px;
        }
        .mg-sub-title {
            font-size: 12px;
            line-height: 18px;
            margin-top: 0;
            margin-bottom: 15px;
        }
        .content-box {
            padding: 0;
            flex-direction: column;
            min-height: auto;
            display: block;
        }

        .left-content,
        .right-content {
            height: 255px;
            border-radius: 10px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &.left-content {
                margin-bottom: 15px;
                margin-right: 0;
            }
        }
        .left-img,
        .right-img {
            border-radius: 10px;
            height: 100%;
        }
        .text-box {
            padding: 0 41px;
            .title {
                margin-bottom: 20px;
                font-size: 24px;
                line-height: 24px;
                p{
                   font-size: 24px;
                   line-height: 24px; 
                }
            }
            .desc {
                font-size: 12px;
                line-height: 18px;
            }
        }
        .banner-button {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 20px;
            bottom: 20px;
            .btn-item {
                height: 30px;
                line-height: 28px;
                min-width: 30px;
                border-radius: 50%;
                margin: 0;
                padding: 0;
                i {
                    font-size: 14px;
                    vertical-align: middle;
                }
            }
        }
    }
}
</style>
